import * as React from 'react';
import { useParams } from 'react-router-dom';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import SafetyInspectionPageView from '../features/activities/SafetyInspectionPageView';

export default function SafetyInspectionPage(): JSX.Element {
    
    const params = useParams<{ activityId: string }>();
    return (
        <ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey="safetyinspection">
            {params.activityId 
                ? <SafetyInspectionPageView activityId={params.activityId} />
                : <span>ugyldig url</span>
        }
        </ProtectedPageWrapper>
    );
}
